export const getDefaultTeeBoxOptions = () => {
  return [
    'Aqua',
    'Back',
    'Beginners',
    'Belle',
    'Black',
    'Blue',
    'Bronze',
    'Championship',
    'Combo A',
    'Combo B',
    'Combo C',
    'Combo D',
    'Combo',
    'Copper',
    'Diamond',
    'Family',
    'Forward',
    'Gold',
    'Green',
    'Grey',
    'Jade',
    'Junior',
    'Ladies Forward',
    'Ladies Member',
    'Member',
    'Middle',
    'Mixed',
    'Normal',
    'Orange',
    'Pink',
    'Professional',
    'Red',
    'Regular',
    'Ruby',
    'Sapphire',
    'Senior',
    'Silver',
    'T1',
    'T2',
    'T3',
    'T4',
    'T5',
    'Teal',
    'Tournament',
    'Turquoise',
    'White',
    'Yellow',
  ]
}
